/* 🧩 COMPONENTS */
import SideBar from "../SideBar";
import MenuButton from "../SideBar/components/MenuButton";
import MobileHeader from "../SideBar/components/MobileHeader";
import Iris from "../Iris";

/* 🎨 STYLES */
import { Container } from "./styles";

const Template = (props) => {
    return (
        <Container>
            <MobileHeader/>
            <MenuButton/>
            <SideBar/>
            {props.child}
            {/* <Iris/> */}
        </Container>
    );
}

export default Template;
